/**
 * CartActions.js — "View cart" / "Proceed to checkout" row (kind "cart-actions").
 *
 * Parity: old createWineListing appended an .order-actions block under the wine
 * carousel (script.js 1949-1955). chat-handler emits this message after a wine
 * card carousel when the cart feature is on. Buttons are events only — the cart
 * feature (features/optional/cart.js) owns opening the cart / checkout.
 *
 * EVENTS OUT:
 *   ws-cart-open   (View cart)
 *   ws-checkout    (Proceed to checkout → Shopify hosted checkoutUrl)
 */

import { emit, on, getState } from "../../../core/state.js";

export default class CartActions {
  render() {
    const row = document.createElement("div");
    row.className = "ws-cart-actions";
    row.style.paddingLeft = '34px';

    const view = document.createElement("button");
    view.type = "button";
    view.className = "ws-cart-action-btn";
    view.textContent = "View Cart";
    view.addEventListener("click", () => emit("ws-cart-open"));
    row.appendChild(view);

    // Parity: old createWineListing rendered "Proceed to checkout" but kept it
    // HIDDEN (data-proceed-checkout: display:none) until the cart had items, then
    // toggled it on cart changes. We render it once and show/hide on ws-cart-count
    // (emitted by cart.js on add/remove) — otherwise this row renders once with an
    // empty cart and the button would never appear after the first Add to cart.
    const checkout = document.createElement("button");
    checkout.type = "button";
    checkout.className = "ws-cart-action-btn";
    checkout.textContent = "Proceed to Checkout";
    checkout.addEventListener("click", () => emit("ws-checkout"));
    row.appendChild(checkout);

    const sync = () => {
      const hasItems = ((getState().cart || {}).items || []).length > 0;
      checkout.style.display = hasItems ? "" : "none";
    };
    sync();
    on("ws-cart-count", sync);

    return row;
  }
}
